import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=b1f56696&scoped=true"
import script from "./ProductCreate.vue?vue&type=script&lang=js"
export * from "./ProductCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f56696",
  null
  
)

export default component.exports